import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const user = JSON.parse(localStorage.getItem('datosUsuario'));
  


  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false); // para cerrar después de hacer clic en un link

  const styles = {
    nav: {
      backgroundColor: 'white',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 1rem',
    },
    navContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '4rem',
    },
    logo: {
      height: '2.5rem',
      width: '10rem',
      marginRight: '0.5rem',
    },
    menuButton: {
      color: '#4a5568',
      outline: 'none',
    },
    menuIcon: {
      width: '1.5rem',
      height: '1.5rem',
    },
    menuContainer: {
      display: menuOpen ? 'block' : 'none',
      '@media (min-width: 768px)': {
        display: 'flex',
      },
    },
    menuItems: {
      display: 'flex',
      flexDirection: 'column',
      '@media (min-width: 768px)': {
        flexDirection: 'row',
        alignItems: 'center',
        gap: '1rem',
      },
    },
    navLink: {
      padding: '0.5rem 1rem',
      fontWeight: '600',
      transition: 'all 0.3s ease',
      color: '#4a5568',
      '&:hover': {
        color: '#8B0000',
      },
    },
    activeLink: {
      color: '#8B0000',
      borderBottom: '4px solid #8B0000',
    },
    userSection: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
    },
    userName: {
      fontWeight: '600',
      color: '#8B0000',
    },
    userAvatar: {
      width: '2rem',
      height: '2rem',
      backgroundColor: '#e2e8f0',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    loginButton: {
      backgroundColor: '#8B0000',
      color: 'white',
      fontWeight: 'bold',
      padding: '0.75rem 1.5rem',
      borderRadius: '0.5rem',
      transition: 'all 0.3s ease',
      '&:hover': {
        backgroundColor: '#A52A2A',
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 12px rgba(139, 0, 0, 0.2)',
      },
    },
    registerButton: {
      backgroundColor: '#ffffffff',
      color: '#4a5568',
      fontWeight: 'bold',
      padding: '0.5rem 1rem',
      borderRadius: '0.5rem',
      transition: 'all 0.3s ease',
      '&:hover': {
        backgroundColor: '#e2e8f0',
        transform: 'translateY(-2px)',
      },
    },
  };

  return (
    <nav className="bg-white shadow-lg">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex items-center justify-between md:justify-start h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center" onClick={closeMenu}>
              <img src="/frabas.png" alt="FRABAS Logo" className="h-10 w-40 mr-2" />
            </Link>
          </div>

          {/* Botón hamburguesa - solo visible en móvil */}
          <div className="md:hidden">
            <button onClick={toggleMenu} className="text-gray-700 focus:outline-none">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>

{/* Menú de navegación */}
<div
  className={`
    ${menuOpen ? 'block' : 'hidden'}
    md:flex md:items-center md:space-x-4
    absolute md:static top-16 left-1/2 md:left-0 transform md:transform-none -translate-x-1/2 md:translate-x-0
    w-11/12 md:w-auto
    bg-white md:bg-transparent
    shadow-2xl md:shadow-none
    z-50
    rounded-2xl md:rounded-none
    p-4 md:p-0
    transition-all duration-300
  `}
  style={{ maxWidth: '340px' }}
>
  <nav className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4">
    {[
      { path: '/', label: 'Inicio' },
      { path: '/services', label: 'Servicios' },
      { path: '/cotizaciones', label: 'Cotizaciones' },
      { path: '/camiones', label: 'Camiones' },
      { path: '/nosotros', label: 'Nosotros' },
      { path: '/seguimiento', label: 'Seguimiento' },
      { path: '/trabaja-con-nosotros', label: 'Postúlate' },
    ].map(({ path, label }) => (
      <Link
        key={path}
        to={path}
        onClick={closeMenu}
        className={`block text-center py-2 px-4 rounded-lg font-semibold transition duration-300 ${
          location.pathname === path
            ? 'text-[#8B0000] bg-[#f3eaea] border-b-4 border-[#8B0000]'
            : 'text-gray-700 hover:bg-[#f3eaea] hover:text-[#8B0000]'
        }`}
      >
        {label}
      </Link>
    ))}

    {user ? (
      <div className="flex flex-col md:flex-row items-center gap-2 md:gap-4 mt-2 md:mt-0">
        <span className="font-semibold text-[#8B0000]">Hola, {user.usuario}</span>
        <Link to="/perfil" onClick={closeMenu}>
          <div className="w-8 h-8 bg-gray-300 rounded-full flex items-center justify-center">
            <i className="fas fa-user"></i>
          </div>
        </Link>
      </div>
    ) : (
      <div className="flex flex-col md:flex-row items-center gap-2 md:gap-4 mt-2 md:mt-0">
       <Link
          to="/iniciosesion"
          onClick={closeMenu}
          className="bg-[#8B0000] hover:bg-[#A52A2A] text-white font-bold py-2 w-32 px-0 rounded transition duration-300 text-center"
        >
          Acceso
        </Link>
        <Link
          to="/register"
          onClick={closeMenu}
          className="bg-[#8B0000] hover:bg-[#A52A2A] text-white font-bold py-2 w-32 px-0 rounded transition duration-300 text-center"
        >
          Registrarse
        </Link>
      </div>
    )}
  </nav>
</div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
